import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "WineBottle.svg",
  "use": "WineBottle.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"WineBottle.svg\"><path d=\"M25,60a3,3,0,0,1-3-3V30c0-6.6181,6-6.0449,6-10V19a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v1c0,3.9551,6,3.3819,6,10V57a3,3,0,0,1-3,3ZM35,16H29a1,1,0,0,1-1-1V6a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v9A1,1,0,0,1,35,16Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol